import { cssRule } from 'typestyle'

cssRule('.geosuggest', {
  fontSize: '18px',
  position: 'relative',
  width: '50%',
  margin: '1em auto',
  marginLeft: '0.5em',
  marginRight: '5.5em',
  textAlign: 'left'
})
cssRule('.geosuggest__input', {
  width: '100%',
  border: '2px solid transparent',
  boxShadow: '0 0 1px #3d464d',
  padding: '.5em 1em',
  transition: 'border 0.2s, box-shadow 0.2s',
  $nest: {
    '&:focus': {
      borderColor: '#267dc0',
      boxShadow: '0 0 0 transparent'
    }
  }
})
cssRule('.geosuggest__suggests', {
  position: 'absolute',
  top: '100%',
  left: '0',
  right: '0',
  maxHeight: '25em',
  padding: '0',
  marginTop: '-1px',
  background: '#fff',
  border: '2px solid #267dc0',
  borderTopWidth: '0',
  overflowX: 'hidden',
  overflowY: 'auto',
  listStyle: 'none',
  zIndex: 5,
  transition: 'max-height 0.2s, border 0.2s'
})
cssRule('.geosuggest__suggests--hidden', {
  maxHeight: 0,
  overflow: 'hidden',
  borderWidth: 0
})
cssRule('.geosuggest__suggests--hidden', {
  maxHeight: '0',
  overflow: 'hidden',
  borderWidth: '0'
})
cssRule('.geosuggest__item', {
  fontSize: '18px',
  padding: '.5em .65em',
  cursor: 'pointer',
  $nest: {
    '&:focus, &:hover': {
      background: '#f5f5f5'
    }
  }
})
cssRule('.geosuggest__item--active', {
  background: '#267dc0',
  color: '#fff',
  $nest: {
    '&:focus, &:hover': {
      background: '#ccc'
    }
  }
})
cssRule('.geosuggest__item__matched-text', {
  fontWeight: 'bold'
})



// WEBPACK FOOTER //
// ./src/styles/TouristPage.styles.ts